import closeSelect from "../assets/images/close-select.png";
import {getAdvancedSearchStyles} from "./advancedSearch.js";

export const globalStyles = (fontSize, hasHydrated) => {
  return {
    html: {
      fontSize: fontSize || "1rem",
    },
    body: {
      // display: !hasHydrated ? "none" : "block",
      margin: 0,
      padding: 0,
      ".no-overflow": {
        overflow: "hidden",
      },
      "*": {
        scrollBehavior: "smooth",
      },
    },
    ".maplibregl-popup-close-button": {
      outline: "none",
      opacity: 0,
    },
    ".maplibregl-popup-content": {
      minWidth: "80px",
    },
    ".maplibregl-ctrl-attrib-inner": {
      fontSize: 0,
      display: "flex !important",
      alignItems: "center !important",
      "a:first-of-type": {
        display: "none",
      },
    },
    ".maplibregl-ctrl-attrib-inner a": {
      fontSize: "initial",
      "@media only screen and (max-width: 600px)": {
        fontSize: "12px",
      },
    },
    ".maplibregl-ctrl-attrib-inner a:nth-of-type(1)": {
      display: "none",
    },
    ".maplibregl-ctrl-attrib-inner a:nth-of-type(2)": {
      marginRight: "7px",
    },

    ".lockScroll": {
      height: "100vh",
      position: "fixed",
      width: "100%",
      overflow: " hidden !important",
    },
    ".sort-select-container": {
      ".sort-select__control": {
        cursor: "pointer",
        border: "none",
        "&.sort-select__control--is-focused": {
          boxShadow: "none",
        },
        "&.sort-select__control--menu-is-open": {
          border: "none",
          " svg": {
            transform: "rotate(180deg)",
          },
        },
        ".sort-select__value-container": {
          padding: "0 0 0 0.5rem",
          ".sort-select__single-value": {
            color: "#27509B",
            fontFamily: "Manrope",
            fontSize: "1.125rem",
            fontWeight: 400,
            lineHeight: "26px",
            textAlign: "left",
          },
        },
        ".sort-select__indicators": {
          ".sort-select__indicator-separator": {
            display: "none",
          },
          ".sort-select__indicator svg": {
            color: "#27509B",
            height: 24,
            width: 24,
            transition: "all 0.5s",
          },
        },
      },
      ".sort-select__menu": {
        right: "-10%",
        top: "80%",
        width: "auto",
        boxShadow: "0 0 0 1px #fff, 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        borderRadius: "16px",
        "@media only screen and (max-width: 600px)": {
          position: "fixed",
          top: "80%",
          left: "0px",
          bottom: "-10px",
          zIndex: 999,
          width: "100vw",
          paddingTop: "50px",
          "&:before": {
            content: '"Trier par :"',
            position: "absolute",
            top: "30px",
            left: "20px",
            width: "fit-content",
            color: "#000",
            fontSize: "18px",
            lineHeight: "24px",
            fontWeight: "bold",
            fontFamily: "Manrope",
          },
          "&:after": {
            content: '""',
            position: "absolute",
            top: "25px",
            right: "20px",
            width: "40px",
            height: "40px",
            backgroundImage: `url(${closeSelect})`,
            backgroundSize: "40px",
          },
          "@media only screen and (max-width: 400px)": {
            top: "490px",
          },
          "@media only screen and (max-width: 376px)": {
            top: "380px",
          },
        },
        ".sort-select__menu-list": {
          padding: "10px 15px 10px 50px",
          cursor: "pointer",
          "@media only screen and (max-width: 600px)": {
            maxWidth: "200px",
          },
          ".sort-select__option": {
            backgroundColor: "white !important",
            position: "relative",
            padding: "6px 6px",
            fontFamily: "Manrope",
            fontSize: "1.125rem",
            fontWeight: 400,
            lineHeight: "26px",
            whiteSpace: "nowrap",
            transition: "all 0.3s",
            cursor: "pointer",
            "&:before": {
              content: "''",
              position: "absolute",
              width: "16px",
              height: "16px",
              borderRadius: "50%",
              left: "-30px",
              top: "10px",
              border: "2px solid #C0C0C0",
              transition: "all 0.3s",
            },
            "&:after": {
              content: "''",
              position: "absolute",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              left: "-26px",
              top: "14px",
              backgroundColor: "#FFF",
              transition: "all 0.3s",
            },
            "&:hover": {
              backgroundColor: "white",
              "&.sort-select__option--is-focused": {
                color: "#000",
                transition: "all 0.3s",
                "&:after": {
                  backgroundColor: "#27509B",
                },
              },
            },
            "&.sort-select__option--is-selected": {
              backgroundColor: "#FFFFFF",
              color: "#000",
              transition: "all 0.3s",
              "&:after": {
                backgroundColor: "#27509B",
              },
            },
          },
        },
      },
    },
    ".form-select-container": {
      position: "relative",
      margin: "35px 0 5px 0",
      ":after": {
        content: "''",
        position: "absolute",
        bottom: 1,
        left: 0,
        width: "100%",
        height: 2,
        backgroundColor: "#BECBE1",
        WebkitClipPath: "polygon(0.5% 100%, 0% 1%, 99.5% 0%, 100% 100%)",
        clipPath: "polygon(0.5% 100%, 0% 1%, 99.5% 0%, 100% 100%)",
      },
      ".form-select__control": {
        border: "none",
        backgroundColor: "transparent",
        "&.form-select__control--is-focused": {
          boxShadow: "0 0 0 1px transparent",
        },
        "&.form-select__control--menu-is-open svg": {
          transform: "rotate(180deg)",
        },
        ".form-select__value-container": {
          padding: "0",
          ".form-select__placeholder": {
            color: "#1D3140",
            fontFamily: "Manrope",
            fontSize: "1.125rem",
            fontWeight: 400,
            lineHeight: "26px",
            textAlign: "left",
            letterSpacing: "2%",
          },
          ".form-select__single-value": {
            color: "#1D3140",
            fontFamily: "Manrope",
            fontSize: "1.125rem",
            fontWeight: 400,
            lineHeight: "26px",
            textAlign: "left",
            letterSpacing: "2%",
          },
        },
        ".form-select__indicators": {
          ".form-select__indicator-separator": {
            display: "none",
          },
          ".form-select__indicator ": {
            padding: "0",
            svg: {
              color: "#27509B",
              height: 40,
              width: 40,
              transition: "all 0.5s",
            },
          },
        },
      },
      ".form-select__menu": {
        ".form-select__menu-list": {
          ".form-select__option": {
            fontFamily: "Manrope",
            fontSize: "1.125rem",
            fontWeight: 400,
            lineHeight: "26px",
            "&.form-select__option--is-focused": {
              backgroundColor: "#27509B",
              color: "#FFFFFF",
            },
            "&.form-select__option--is-selected": {
              backgroundColor: "#27509B",
              color: "#FFFFFF",
            },
          },
        },
      },
    },
    ...getAdvancedSearchStyles(),
    ".plan-trip-select-container": {
      position: "relative",
      marginBottom: "5px",
      marginRight: "20px",
      ":after": {
        content: "''",
        position: "absolute",
        bottom: -8,
        left: -53,
        width: "calc(90% + 53px)",
        height: 4,
        backgroundColor: "#1095F9",
        WebkitClipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
        clipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
        "@media only screen and (max-width: 768px)": {
          bottom: -5,
          left: -48,
          height: 2,
        },
        "@media only screen and (max-width: 475px)": {
          bottom: 0,
          left: -38,
          height: 2,
        },
      },
      ".plan-trip-select__control": {
        border: "none",
        backgroundColor: "transparent",
        "&.plan-trip-select__control--is-focused": {
          boxShadow: "0 0 0 1px transparent",
        },
        "&.plan-trip-select__control--menu-is-open svg": {
          transform: "rotate(180deg)",
        },
        ".plan-trip-select__value-container": {
          padding: "0",
          ".plan-trip-select__placeholder": {
            fontFamily: "Arvo",
            fontSize: "2.5rem",
            fontStyle: "italic",
            fontWeight: 400,
            lineHeight: "48px",
            textAlign: "left",
            letterSpacing: "0.02em",
            color: "#C0C0C0",
            "@media only screen and (max-width: 768px)": {
              fontSize: "2rem",
              lineHeight: "2.125rem",
            },
            "@media only screen and (max-width: 475px)": {
              fontSize: "1.5rem",
              fontFamily: "Arvo",

              lineHeight: "2.125rem",
            },
          },
          ".plan-trip-select__single-value": {
            color: "#1D3140",

            fontFamily: "Arvo",
            fontSize: "2.5rem ",
            lineHeight: "3rem ",
            fontStyle: "italic ",
            fontWeight: 400,
            marginRight: 8,
            "@media only screen and (max-width: 768px)": {
              fontSize: "2rem",
              fontFamily: "Arvo",
              fontWeight: 400,
              lineHeight: "2.125rem",
            },

            "@media only screen and (max-width: 475px)": {
              color: "#1D3140",
              fontFamily: "Arvo",
              fontSize: "1.5rem",
              fontWeight: 400,
              lineHeight: "2rem",
              textAlign: "left",
              letterSpacing: "2%",
            },
          },
          ".plan-trip-select__input-container ": {},
        },
        ".plan-trip-select__indicators": {
          ".plan-trip-select__indicator-separator": {
            display: "none",
          },
          ".plan-trip-select__indicator ": {
            padding: "0",
            svg: {
              color: "#27509B",
              height: 30,
              width: 30,
              transition: "all 0.5s",
              "@media only screen and (max-width: 600px)": {
                height: 25,
                width: 25,
              },
            },
          },
        },
      },
      ".plan-trip-select__menu": {
        minWidth: "254px",
        marginTop: 24,
        left: "-60px",
        borderRadius: "24px",
        "@media only screen and (max-width: 768px)": {
          left: "-52px",
        },
        ".plan-trip-select__menu-list": {
          marginRight: "12px",
          scrollbarColor: "red",
          marginTop: "20px",
          marginBottom: "20px",
          ".plan-trip-select__option": {
            fontFamily: "Manrope",
            fontSize: "1.5rem",
            fontStyle: "italic",
            fontWeight: 400,
            lineHeight: "1.875rem",
            color: "#1D3140",
            padding: "12px 24px",
            "&.plan-trip-select__option--is-focused": {
              backgroundColor: "#FFFFFF",
              color: "#27509B",
            },
            "&.plan-trip-select__option--is-selected": {
              backgroundColor: "#FFFFFF",
              color: "#27509B",
            },
          },
          "::-webkit-scrollbar": {
            width: "3px",
            height: "3px",
            backgroundColor: "transparent",
          },
          "::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
          "::-webkit-scrollbar-track-piece": {
            backgroundColor: "#C0C0C0",
          },
          "::-webkit-scrollbar-thumb": {
            backgroundColor: "#000",
            borderRadius: "10px",
            border: "none",
          },
          "::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#555",
          },
          "::-webkit-scrollbar-corner": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    p: {
      margin: 0,
    },
    mark: {
      backgroundColor: "#FCE500",
    },
  };
};
